import React, { FC } from "react";
import QueryIhx from "../../../../components/patient/Query/IHX/QueryIhx";

type QueryContainerIhxProps = {
  createQuery: boolean;
  closeCreateQueryModal: any;
  activeStage: any;
};

const QueryContainerIhx: FC<QueryContainerIhxProps> = ({
  createQuery,
  closeCreateQueryModal,
  activeStage,
}) => {
  return (
    <div>
      <QueryIhx
        createQuery={createQuery}
        closeCreateQueryModal={closeCreateQueryModal}
        activeStage={activeStage}
      />
    </div>
  );
};

export default QueryContainerIhx;
